@if (showTokenizeNotice$ | async) {
<p class="tokenize-only-notice">{{ 'TokenizeOnlyNotice' | translate }}</p>
}
@if (appFacadeService.getSelectedContractsModels() | async; as contract) { @if (contract.length > 0) { @if (customer$ | async | count) {
<por-multipayment></por-multipayment>
} } }
<por-payment-success-dialog></por-payment-success-dialog>

@if (appFacadeService.getContractDetailError() | async; as error) {
<div class="error-message">
    <p>{{ error }}</p>
</div>
}
